// extracted by mini-css-extract-plugin
export default {"modalContent":"ProductLimitModal_modalContent__DGOHJ"};